<template>
  <b-modal :id="modalId" size="xl" centered @hidden="hide" modal-class="modal-digital-items"
           :footer-class="'justify-content-center'">

    <template v-slot:modal-header>
      <div class="fraction">{{ realIndex }}/{{ photos.length }}</div>
      <button type="button" aria-label="Close" class="close" @click="hide"></button>
    </template>
    <span v-touch:swipe.bottom="onSwipeBottom">
        <swiper-slider :has-navigation="true"
                       :extra-class="'slider-photo-gallery'"
                       :selected-index="selectedIndex"
                       :zoom="true"
                       v-on:slide-change="onSlideChange">
          <template v-slot:slides>
            <div class="swiper-slide" v-for="(slide, index) in photos" :key="index">
              <div class="swiper-zoom-container swiper-item">
                <img :data-src="slide.image_url" class="swiper-lazy">
              </div>
            </div>
          </template>
        </swiper-slider>

    </span>
    <template v-slot:modal-footer>
      <div class="d-flex align-items-center">
        <ul class="nav nav-pills align-items-center">
<!--          <li class="nav-item" v-if="showPhotoPackage && !showPhotoVideoPackage">
            <ButtonPackage :label="$t('pages.checkins_detail.package_photos_btn_buy_all')"
                           :price="priceForAllPhotos"
                           :loading="loadingBuyPackage"
                           :is-already-added="isAlreadyAddedPackagePhoto"
                           :extra-class="'btn-buy&#45;&#45;package-photos'"
                           @click="callActivatePackage('photopackage')"/>
          </li>
          <li class="nav-item" v-if="showPhotoVideoPackage">
            <ButtonPackage :label="$t('pages.checkins_detail.package_photos_videos_btn_buy_all')"
               :price="priceForAllPhotos"
               :loading="loadingBuyPackage"
               :is-already-added="isVideoPackageAlreadyInCart"
               :extra-class="'btn-buy--package-photos-videos'"
               @click="callActivatePackage('video')"/>
          </li>-->
          <li class="nav-item">
            <ButtonToggleCart :action="actionCart" :loading="loading" @click="toggleSelection()"/>
          </li>
        </ul>
      </div>
    </template>

  </b-modal>
</template>


<script>
import SwiperSlider from "@/components/SwiperSlider";
import {ADD_TO_CART, REMOVE_TO_CART} from "@/components/interface/svg/IconCart";
import ButtonToggleCart from "@/components/ButtonToggleCart";
import ButtonPackage from "@/components/ButtonPackage";
import Gallery from "@/domain/metrics/gallery";

export default {
  props: ['photos', 'eventName', 'eventDate', 'picacode', 'digitalItemId', 'useSelectLabel'],
  components: {
    ButtonPackage,
    ButtonToggleCart,
    SwiperSlider,
  },

  data() {
    return {
      selectedIndex: 0,
      currentPhotoId: '',
      justOpened: true,
      //addedToCart: false,
      //loading: false,
      loadingBuyPackage: false,

      // populated from root checkin
      refRoot: undefined,

      showPhotoPackage: false,
      priceForAllPhotos: '',
      isAlreadyAddedPackagePhoto: false,

      showPhotoVideoPackage: false,
      isVideoPackageAlreadyInCart: false,
      priceForAllPhotosAndVideos: ''
    }
  },

  computed: {
    realIndex() {
      return this.selectedIndex + 1
    },
    actionCart() {
      return this.addedToCart ? REMOVE_TO_CART : ADD_TO_CART
    },
    loading(){
     return this.$parent.$refs.collagePhotoItemBuyable[this.selectedIndex].loading
    },
    addedToCart(){
     return this.$parent.$refs.collagePhotoItemBuyable[this.selectedIndex].addedToCart
    }
  },


  created() {
    this.modalId = 'bv-modal-photo-gallery'

    // read some data from root (CheckInDetail.vue)
    /*this.refRoot = this.$root.$children[0].$refs.refView
    this.priceForAllPhotos = this.refRoot.priceForAllPhotos
    this.showPhotoPackage = this.refRoot.showDefaultBanners && this.refRoot.isPhotoPackageBannerEnabled

    this.isAlreadyAddedPackagePhoto = this.getPackagePhotoState()
    this.isVideoPackageAlreadyInCart = this.getPackagePhotoVideoState()
    this.priceForAllPhotosAndVideos = this.refRoot.priceForAllPhotosAndVideos
    this.showPhotoVideoPackage = this.refRoot.hasBuyableVideos*/
  },

  methods: {
    /*getPackagePhotoState() {
      return this.refRoot.isPhotoPackageAlreadyInCart && !this.refRoot.isVideoPackageAlreadyInCart
    },
    getPackagePhotoVideoState() {
      return this.refRoot.isVideoPackageAlreadyInCart
    },*/

    show(index) {
      this.$set(this, 'selectedIndex', index)
      this.justOpened = true
      this.setCurrentPhotoData(this.photos[index])
      this.$bvModal.show(this.modalId)
    },

    hide() {
      this.$bvModal.hide(this.modalId)
      // this.resetCurrentPhotoData()
    },

    onSlideChange(selectedIndex) {
      const currentPhoto = this.photos[selectedIndex]
      this.setCurrentPhotoData(currentPhoto)
      Gallery.mediaOpened(this.currentPhotoId)

      // The first photo opened was viewed from the gallery, when we scroll the gallery we count it as view
      // to avoid "more open than view" problem
      if (this.justOpened) this.justOpened = false
      else Gallery.mediaViewed(this.currentPhotoId)

      this.$set(this, 'selectedIndex', selectedIndex)
    },

    setCurrentPhotoData(currentPhoto) {
      this.currentPhotoId = currentPhoto.id
      //this.addedToCart = !!this.$store.getters['cart/isDigitalPhotoInCart'](this.picacode, currentPhoto.id)
      //this.currentPhotoDownloadUrl = `${currentPhoto.media_original_url}/download`
      //this.currentPhotoShareUrl = currentPhoto.share_url
      //this.currentPhotoShareDescription = `${this.eventName} - ${this.$options.filters.formatDate(this.eventDate)}`
    },

    resetCurrentPhotoData() {
      this.currentPhotoId = ''
      this.addedToCart = false
      //this.currentPhotoDownloadUrl = ''
      //this.currentPhotoShareUrl = ''
      //this.currentPhotoShareDescription = ''
    },

    // NEW => MOVED FROM CollagePhotoItemBuyable.vue
    toggleSelection() {
      this.addedToCart ? this.removeFromCart() : this.addToCart()
    },

    addToCart() {
      this.$parent.$refs.collagePhotoItemBuyable[this.selectedIndex].addToCart()
    },

    removeFromCart() {
       this.$parent.$refs.collagePhotoItemBuyable[this.selectedIndex].removeFromCart()
    },

    onSwipeBottom() {
       this.$bvModal.hide(this.modalId)
    },

    // FROM ROOT
   /* callActivatePackage(orderType = 'photopackage') {
      this.loadingBuyPackage = true
      this.refRoot.activatePackage(orderType).catch(error=>{
        this.loadingBuyPackage = false
      }).finally(() => {
        //this.loadingBuyPackage = false
        this.getPackagePhotoState()
        this.getPackagePhotoVideoState()
      })
    },*/
  }
}
</script>
